import { IAddressInfoSchema } from '../../../../repositories/monolith-python/entities/offer/AddressInfoSchema';
import { IGeoSchema } from '../../../../repositories/monolith-python/entities/offer/GeoSchema';
import { IOfferState } from '../../../../redux/reducers';
import { mapHighways } from './mapHighways';
import { mapJK } from './mapJK';
import { mapUndergrounds } from './mapUndergrounds';

export const mapGeo = (offer: IOfferState): IGeoSchema | null => {
  const { geo } = offer;

  if (!geo) {
    return null;
  }

  const {
    undergrounds: undergroundsRaw,
    highways: highwaysRaw,
    jk: jkRaw,
    address: addressRaw,
    ...restGeo // tslint:disable-line:trailing-comma
  } = geo;

  const undergrounds = mapUndergrounds(undergroundsRaw);
  const highways = mapHighways(highwaysRaw);
  const jk = mapJK(jkRaw);
  const address = addressRaw as unknown as Array<IAddressInfoSchema>;

  return {
    ...restGeo,
    undergrounds,
    highways,
    jk,
    address,
  };
};
